import React, { useState, useEffect } from 'react';
import MyAccountTabs from 'layouts/MyAccountTabs';
import GeneralForm from 'components/GeneralForm';
import { tabItems } from '.';
import ProfileService from 'services/ProfileService';
import Notification from 'components/Notification';
import useStudyFields from 'hooks/useStudyFields';
import useRoles from 'hooks/useRoles';
import getCleverTap from 'utils/clevertap';
import { useAuthUser } from 'features/auth/AuthUserContext';
import { withAuth } from 'features/auth/withAuth';
import LoadingCircle from 'components/LoadingCircle';
import { AuthTypeEnum } from 'features/auth/utils';
import { useRouter } from 'next/router';
import { EditageConfig } from 'config/onelogin.config';

function General() {
  const router = useRouter();
  const { user, profile, authType, isLoading: isLoadingUser } = useAuthUser();
  const profileService = new ProfileService();
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState('');
  const [formData, setFormData] = useState({
    image: '',
    name: '',
    email: '',
    institution: '',
    role: '',
    fieldOfStudy: '',
    gender: '',
    whatsappNumber: '',
  });
  const getStudyFields = useStudyFields();
  const getRoles = useRoles();
  const clevertap = getCleverTap();

  useEffect(() => {
    if (authType !== AuthTypeEnum.SAML && !isLoadingUser) {
      router.push(`${EditageConfig.partnerUrl[user.cactusPartnerId]}/account/profile`);
    } else if (profile.name && user.email) {
      setFormData({
        image: profile.picture,
        name: profile.name,
        email: user.email,
        institution: profile.institution,
        role: profile.idRole,
        fieldOfStudy: profile.idStudyField,
        gender: profile.gender,
        whatsappNumber: profile.whatsappNumber,
      });
    }
  }, [profile, user, authType, isLoadingUser]);

  function handleChange(value, name) {
    setFormData({
      ...formData,
      [name]: value,
    });
  }

  async function saveChanges() {
    const nameOfStudyField = getStudyFields[formData.fieldOfStudy - 1]?.name;
    const nameOfRole = getRoles[formData.role - 1]?.role;

    setIsLoading(true);

    try {
      await profileService.update(user.id, {
        name: formData.name,
        idRole: formData.role,
        idStudyField: formData.fieldOfStudy,
        institution: formData.institution,
        gender: formData.gender,
        whatsappNumber: formData.whatsappNumber,
      });

      clevertap.profile.push({
        Site: {
          Name: formData.name,
          Email: user.email,
          'Gender User': formData.gender,
          Phone: `+ ${formData.whatsappNumber}`,
          'Field of Study': nameOfStudyField,
          Role: nameOfRole,
          Organization: formData.institution,
        },
      });

      setNotification('Changes saved');
    } catch (error) {
      setNotification(error.message);
    }

    setIsLoading(false);
  }

  if (authType === AuthTypeEnum.SAML) {
    return (
      <MyAccountTabs title="Edit data" tabItems={tabItems}>
        <GeneralForm
          {...formData}
          onChange={handleChange}
          onSave={saveChanges}
          isLoading={isLoading}
        />
        <Notification
          isOpen={!!notification}
          message={notification}
          onClose={() => setNotification('')}
        />
      </MyAccountTabs>
    );
  } else {
    return <LoadingCircle />;
  }
}

export default withAuth(General);
